import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

const Wrapper = styled.span`
  border: 1px solid black;
  display: inline-block;
  background-color: #D9D9D9;
  margin-top: 40px;
`;
const SymbolWrapper = styled.span`
  margin-left: 8px;
  margin-right: 8px;
  font-weight: bold;
`;
const StyledNumberFormat = styled(NumericFormat)`
  &&& {
    height: 32px;
  }
  min-width: 20px;
  max-width: 100px;
`;

const NumberInputWithSymbolPropTypes = {
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  value: PropTypes.oneOf([PropTypes.number, PropTypes.string]).isRequired,
  onHandleValueChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['currency', 'count']).isRequired,
};

const NumberInputWithSymbol = ({
  minValue, maxValue, value, onHandleValueChange, type,
}) => {
  const updateValue = values => {
    const { formattedValue } = values;
    let trueValue = parseInt(formattedValue.replace(/[^0-9]/g, ''), 10);
    if (!trueValue) { trueValue = minValue; }
    trueValue = (Math.min(maxValue, Math.max(minValue, trueValue)));
    onHandleValueChange(trueValue);
  };

  if (type === 'currency') {
    return (
      <Wrapper>
        <SymbolWrapper>
          $
        </SymbolWrapper>
        <StyledNumberFormat
          value={value}
          displayType="input"
          thousandSeparator=","
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          onValueChange={updateValue}
        />
      </Wrapper>
    );
  }
  if (type === 'count') {
    return (
      <Wrapper>
        <SymbolWrapper>
          #
        </SymbolWrapper>
        <StyledNumberFormat
          value={value}
          displayType="input"
          thousandSeparator=","
          decimalScale={0}
          fixedDecimalScale
          allowNegative={false}
          onValueChange={updateValue}
        />
      </Wrapper>
    );
  }
  // NOTE: This should never get hit, since we enforce specific types
  return (<span />);
};

NumberInputWithSymbol.propTypes = NumberInputWithSymbolPropTypes;

export default NumberInputWithSymbol;
